// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var InfoWindowShowingType;
(function (InfoWindowShowingType) {
    InfoWindowShowingType[InfoWindowShowingType["None"] = -1] = "None";
    InfoWindowShowingType[InfoWindowShowingType["IntradayAbsoluteChart"] = 0] = "IntradayAbsoluteChart";
    InfoWindowShowingType[InfoWindowShowingType["TicksAbsoluteChart"] = 1] = "TicksAbsoluteChart";
    InfoWindowShowingType[InfoWindowShowingType["PortfolioGrowth"] = 2] = "PortfolioGrowth";
})(InfoWindowShowingType || (InfoWindowShowingType = {}));
